export default __webpack_public_path__ + "static/media/cop2.548ab4e8.png";